// Utility function to notify components about wishlist updates
export const notifyWishlistUpdate = () => {
  window.dispatchEvent(new CustomEvent('wishlistUpdated'));
};
